import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { useForm, SubmitHandler, Controller, set } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import Teaxtarea from "../../../components/elements/form/textarea";
import SelectBox from "../../../components/elements/form/selectBox";
import { Option } from "../../../_config/types";
import Datepicker from "../../../components/elements/form/datepicker";
import Button from "../../../components/elements/button";
import mapImg from "../../../images/map-left.jpg";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import toast from "react-hot-toast";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import { getSelectedOption, getSelectedOptions, localDate, localTime, showLocalDate } from "../../../_common/functions";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { MAP_KEY } from "../../../_config";
import { useAssestCategoriesSelector, useAssestClassificationsSelector, useAssestDepartmentsSelector, useAssestGroupsSelector, useAssestStatuesSelector, useAssestSubGroupsSelector, useAssestTypesSelector, useFacilityManagersSelector } from "../../../store/selectors/masterSelector";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";

import { AgGridReact } from "ag-grid-react";
import { titleCell } from "../../../components/elements/function";
import Label from "../../../components/elements/form/fromLabel";
import { GridApi } from "ag-grid-community";
import { Link } from "react-router-dom";
import CreateAssetsModal from "../../WorkRequest/_components/createAssets.modal";
import Timepicker from "../../../components/elements/form/timePicker";
import moment, { Moment } from "moment";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import FindAssetsWOModalWrapper from "./FindAssetsWOModalWrapper";
import Icon from "../../../components/icons";
import CreateSparePartsModal from "./createSpeareParts.modal";
import { useChecklistApi } from "../../../store/api/hooks/checklistApiHook";
import CreateCheckListsModal from "./createCheckList.modal";
import { useStockAdjustmentApi } from "../../../store/api/hooks/stockAdjustmentApiHook";
import { useCycleCountApi } from "../../../store/api/hooks/cycleCountApiHook";
import { useUserSelector } from "../../../store/selectors/userSelector";
import Loader from "../../../components/loader";

interface AssetsFormProps {
  _ref?: any;
  editData?: any;
  currentStatus?: any;
  onCreate?: () => void;
  onCancel?: () => void;
}

type CreateWorkOrderFormValueType = {
  workOrderID: any;
  ProgressStatusNote: string;
  StartedBy: any;
  OriginalStartDate: Date;
  originalStartTime: Moment | undefined;


  assetImage: any;
};

const InprogressModalWorkOrder: React.FC<AssetsFormProps> = ({ _ref, editData, currentStatus, onCreate = () => { }, onCancel = () => { } }) => {

  const hasEditRun = useRef(false);

  const { control, handleSubmit, setValue, reset, formState: { errors }, watch, getValues } = useForm<CreateWorkOrderFormValueType>({
    defaultValues: {
    },
  });

  const { showLoader, hideLoader } = useAppLoader();
  const commonApi: any = useCommonApi();
  const workOrderAPI: any = useWorkOrderApi();
  const user: any = useUserSelector();
  const users: any = useFacilityManagersSelector();

  const [partsAttachment, setPartsAttachment] = useState<any>(null);
  const [woloader, setWoloader] = useState<boolean>(false);
  const loggedinuser: any = useUserSelector();


  useImperativeHandle(_ref, () => ({
    open: () => {
      console.log('Modal Opened');
    },
    close: () => {
      console.log('Modal Closed');
    }
  }));

  const changeAttachmentHandler = (e: any) => {
    setPartsAttachment(e.target.files);
  };

  const formReset = async () => {
  };

  const onSubmit: SubmitHandler<CreateWorkOrderFormValueType> = async (data: any) => {
    //  const AssData = selectedAssets.map((node: any) => node.assetID);
    if (editData && editData.workOrderID) {
      const datetime = moment().utc().toISOString();
      var payload: any = {
        workOrderID: editData.workOrderID,
        ProgressStatusNote: `Task started by ${loggedinuser?.firstName} ${loggedinuser?.lastName} at ${datetime}`,
        StartedBy: data?.StartedBy?.value || null,
        WorkOrderStatusID: currentStatus
      };
      if (data.OriginalStartDate && data.originalStartTime) {
        payload.OriginalStartDate = moment(moment(data.OriginalStartDate).format(`YYYY-MM-DD`) + " " + data.originalStartTime.format("HH:mm:ss"), `YYYY-MM-DD HH:mm:ss`).utc().toISOString();
      }
      console.log("data is -> ", data);
      console.log("payload is-> ", payload);

      setWoloader(true);
      const statuschangeresp = await new Promise((resolve, reject) => {
        workOrderAPI.UpdateWorkOrderInprogress(payload, (resp: any) => {
          console.log(resp, "Submited resp");
          toast.success(resp?.message);
          resolve(resp);
        }, (error: any) => {
          toast.error(error);
        });
      }).catch((error: any) => { return [] });
      if (partsAttachment) {
        const formData = new FormData();
        var i = 0;
        for await (const item of partsAttachment) {
          formData.append("InputFile" + i, item);
          i++;
        }
        formData.append("WorkOrderstatus", "InProgress");
        formData.append("workOrderID", editData?.workOrderID);
        const partsattachresp = await new Promise((resolve, reject) => {
          //for (let i = 0; i < partsAttachment.length; i++) {                                      
          workOrderAPI.UploadWorkOrderCompletionAttachment(formData, (resp: any) => {
            toast.success(resp?.message);
            resolve(resp);
          }, (error: any) => {
            toast.error(error);
            reject(error);
          });
        }).catch((error: any) => { return null });
      }
      hasEditRun.current = false;
      onCreate();
      formReset();
      setWoloader(false);
    }
    console.log("Submit payload", payload);
  };


  const init_page_date = async () => {
    //GetAssignmentTypeList();
    //GetTechnicianList();
  }

  useEffect(() => {
    init_page_date();
  }, []);


  useEffect(() => {
    if (editData == null) {
      formReset();
    } else {
      console.log("sfsf");
      init_page_date();
    }
  }, [editData]);

  useEffect(() => {
    if (editData && user && users && !hasEditRun.current) {
      setValue("StartedBy", getSelectedOption(user?.userID, users));
      setValue("OriginalStartDate", new Date());
      setValue("originalStartTime", moment());
      //reset({'StartedBy':getSelectedOption(user?.userID,users)});
      hasEditRun.current = true;
    } else {
      formReset();
    }
  }, [editData, user, users]);

  useEffect(() => {
    if (_ref?.current) {
      _ref.current.reset = formReset;
    }
  }, [_ref]);

  return (
    <div>
      {woloader && (
        <div className={`absolute p-8`} style={{ height: "100%", width: "100%", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.5)" }}>
          <Loader />
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className={`${woloader ? `hidden` : `flex`} flex-col`}>
        <div className="flex-1 overflow-auto" style={{ minHeight: `calc(100vh - 152px)` }}>
          {/* <Controller
            name="ProgressStatusNote"
            rules={{ required: "Status Note is required" }}
            control={control}
            render={({ field: { value, onChange } }) => (
              <Teaxtarea
                label="Status Note"
                value={value}
                onChange={onChange}
                required
                placeholder="Status Note"
                error={errors.ProgressStatusNote?.message as any}
              />
            )}
          /> */}
          <Controller
            name="StartedBy"
            control={control}
            rules={{ required: "User name is required" }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="User name"
                value={value}
                onChange={(SelectOption: any) => {
                  onChange(SelectOption);
                }}
                required
                className={`!my-3`}
                placeholder="User name Type"
                options={users}
                error={errors.StartedBy?.message as any}
              />
            )}
          />
          <div className="grid grid-cols-2 mt-1 gap-2 relative">
            <Controller
              name="OriginalStartDate"
              control={control}
              rules={{ required: "Start Time is required" }}
              render={({ field: { value, onChange } }) => (
                <Datepicker
                  label="Date"
                  required
                  value={value}
                  onChange={onChange}
                  className={`!my-3`}
                  error={errors.OriginalStartDate?.message}
                />
              )}
            />
            <Controller
              name="originalStartTime"
              rules={{ required: "Start Time is required" }}
              control={control}
              render={({ field: { value, onChange } }) => (
                <Timepicker
                  label="Time"
                  value={value}
                  onChange={onChange}
                  className={`!my-3`}
                  required
                  error={errors.originalStartTime?.message}
                />
              )}
            />
          </div>

          <Controller
            name="assetImage"
            control={control}
            render={({ field: { value, onChange } }) => (
              <FileUpload
                label="File name"
                value={value}
                isMulti={true}
                accept=".jpg, .jpeg, .png"
                isFigmaType={true}
                className={`!my-1 mb-5`}
                retainFiles={true}
                allowedExt={[`jpg`, `jpeg`, `png`, `gif`]}
                onChange={(e: any, files: any) => {
                  changeAttachmentHandler(e);
                  onChange(e.target.files[0]);
                }}
                placeholder="Choose Processing Facility"
              />
            )}
          />
        </div>

        <div className="flex justify-end gap-2 flex-shrink-0 pt-5 pb-1 border-t" style={{ borderTopColor: `#50575B` }}>
          <Button type="submit" customstyle={{ background: `#2D6A32`, width: 142, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}>Start Working</Button>
          <Button type="button" theme="secondary" onClick={() => {
            formReset();
            onCancel();
            hasEditRun.current = false;
          }} customstyle={{ width: 97, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}>
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
};

export default InprogressModalWorkOrder;
